export default __webpack_public_path__ + "assets/img/LivenessGIF-1.6e5c12dc.gif";